/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type AccountIdentifierType =
  typeof AccountIdentifierType[keyof typeof AccountIdentifierType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountIdentifierType = {
  GB_ACCOUNT: 'GB_ACCOUNT',
  GB_SCAN: 'GB_SCAN',
  GB_BBAN: 'GB_BBAN',
  GB_HBCA: 'GB_HBCA',
  IBAN: 'IBAN',
} as const;
